import {RequestMethod} from '#lit/common/constants/index.js';
import {reviewAudiencesLocale} from '#lit/common/locale/review_audiences.js';
import {FlyErrorWarning} from '#lit/utils/errors.js';
import {fetcher} from '#lit/utils/http.js';
import {renderNotification} from '#lit/utils/notifications.js';
import {locale} from '#lit/common/locale/index.js';
import {AlertIntent} from '#lit/components/base/alert/index.js';

class ReviewAudienceService {
  /**
   * Approve an audience
   */
  async approveAudiences(params: {
    audienceIds: number[];
    formToken: string;
  }): Promise<void> {
    const url = '/review_audiences/approvals';
    const formData = new FormData();

    params.audienceIds.forEach(id => {
      formData.append('review_audiences[audience_ids][]', id.toString());
    });

    try {
      await fetcher<void>(url, {
        method: RequestMethod.POST,
        body: formData,
        headers: {
          'X-CSRF-Token': params.formToken,
        },
        responseParser: null,
      });
      renderNotification(
        reviewAudiencesLocale[locale.current].approve.success,
        AlertIntent.SUCCESS
      );
    } catch (err) {
      renderNotification(
        reviewAudiencesLocale[locale.current].approve.error,
        AlertIntent.DANGER
      );
      new FlyErrorWarning('Error approving audiences').register(
        'Error in review audience service'
      );

      throw err;
    }
  }

  async reviewAudience(params: {
    redirectUrl: string;
    postUrl: string;
    audienceId: number;
    formToken: string;
  }): Promise<void> {
    const formData = new FormData();

    try {
      await fetcher<void>(params.postUrl, {
        method: RequestMethod.POST,
        body: formData,
        headers: {
          'X-CSRF-Token': params.formToken,
        },
        responseParser: null,
      });
      location.href = params.redirectUrl;
    } catch (err) {
      renderNotification(
        reviewAudiencesLocale[locale.current].review.error,
        AlertIntent.DANGER
      );
      new FlyErrorWarning('Error reviewing audience').register(
        'Error in review audience service'
      );
      throw err;
    }
  }
}

export const reviewAudienceService = new ReviewAudienceService();
